import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {

  open() {
    this.showDialog();

    // --- Sauvegarde automatique des champs personnalisés ---
    function updateCartAttributes() {
      var date = document.getElementById('delivery-date')?.value || '';
      var hour = document.getElementById('delivery-hour')?.value || '';
      var comment = document.getElementById('delivery-notes')?.value || '';

      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          attributes: {
            "Date de livraison": date,
            "Heure de livraison": hour,
            "Commentaire": comment
          }
        })
      });
    }

    // Surveille les changements dans les champs
    ['delivery-date','delivery-hour','delivery-notes'].forEach(function(id) {
      var el = document.getElementById(id);
      if (el) {
        el.addEventListener('change', updateCartAttributes);
        el.addEventListener('blur', updateCartAttributes);
      }
    });
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}
